// extracted by mini-css-extract-plugin
export default {"btnHolder":"main-button_btnHolder__N-jaT","smallBtn":"main-button_smallBtn__I0Yml","inverseColors":"main-button_inverseColors__HRxav"};